import { FlexGrowCol } from '@xylabs/sdk-react'
import React from 'react'
import { Helmet } from 'react-helmet'

import WorldBasePage from '../WorldBasePage'
import DarkModeProperty from './DarkModeProperty'
import DeveloperModeProperty from './DeveloperModeProperty'
import InfuraDefaultProperty from './InfuraDefaultProperty'
import MapStyleProperty from './MapStyleProperty'
import RequestLocationProperty from './RequestLocationProperty'

const SettingsPage: React.FC = () => {
  return (
    <WorldBasePage>
      <Helmet title="Application Settings" />
      <FlexGrowCol marginY={1} justifyContent="flex-start" alignItems="stretch">
        <InfuraDefaultProperty />
        <DeveloperModeProperty />
        <MapStyleProperty />
        <RequestLocationProperty />
        <DarkModeProperty />
      </FlexGrowCol>
    </WorldBasePage>
  )
}

export default SettingsPage
